import { Chart } from '@antv/g2'
import React from 'react'

export const DashboardPieChart: React.FC<{
  data: any[]
  total: { percentage: null | number; topTotalWorkload: number; totalWorkload: number }
}> = ({ data, total }) => {
  const containerEl = React.useRef<HTMLDivElement>(null)
  const [chart, setChart] = React.useState<Chart>()

  React.useEffect(() => {
    if (!containerEl.current) {
      return
    }
    if (!chart) {
      const chart = new Chart({
        container: containerEl.current,
        width: 260,
        height: 240,
      })
      setChart(chart)
    }
  }, [])

  React.useEffect(() => {
    if (chart) {
      chart.clear()

      chart.coordinate('theta', {
        innerRadius: 0.4,
      })
      chart.data(data)
      chart
        .interval()
        .position('percentage')
        .color('name')
        .adjust('stack')
        .label('percentage', () => {
          return {
            offset: -10,
            style: {
              fontSize: 14,
            },
            content: (obj) => {
              return `${obj.name.length > 4 ? `${obj.name.slice(0, 4)}...` : obj.name}` + '\n' + obj.percentage + '%'
            },
          }
        })
      chart.legend(false)

      chart.tooltip({
        showMarkers: false,
        customItems: (items) => {
          return items.map((item) => ({ ...item, value: `${item.value}%` }))
        },
        showTitle: false,
        domStyles: {
          'g2-tooltip-list-item': { display: 'flex', alignItems: 'baseline' },
          'g2-tooltip-name': { whiteSpace: 'nowrap' },
        },
      })

      chart.annotation().text({
        content: `${((total.percentage ?? 0) * 100).toFixed(2)}%`,
        position: ['50%', '50%'],
        style: {
          fontSize: 24,
          fontWeight: 'bold',
          textAlign: 'center',
        },
      })

      chart.annotation().text({
        content: `${total.topTotalWorkload}/${total.totalWorkload}`,
        position: ['50%', '60%'],
        style: {
          fontSize: 16,
          fontWeight: 'bold',
          textAlign: 'center',
        },
      })

      chart.render()
    }
  }, [data])

  return <div ref={containerEl}></div>
}
